module.exports = __webpack_public_path__ + "img/bg-image-mobile.610c48d5.svg";